export class ProductCode {
  public static Season = ['Season'];
  public static Premium = ['Premium'];
  public static Partner = ['Partner'];
}
